const state = {
    message: '',
    type:'info', //error, success, warning
    show: false,

    timer:null
}

const getters = {
    snack_bar_show: (state) => {
        return state.show
    },
    message: (state) => {
        return state.message
    }
}

const actions = {}

const mutations = {
    snack_bar_fire(state, data) {
        state.message = data.message
        state.type = data.type || 'info'
        state.show = true
        state.timer = setTimeout(()=>{
            if(state.show){
                this.commit('snack_bar/snack_bar_close')
            }
        }, 3000);
    },
    snack_bar_close(state) {
        clearTimeout(state.timer)
        state.timer=null
        state.message = null
        state.show = false
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
